<h1 class="mt-5">Reporte calificaciones parciales por estudiante</h1>

<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0">Criterios de búsqueda</h6>
</div>
<form [formGroup]="parametrosForm">
  <div class="row mt-5">
    <div class="col-2">
      <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
      <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
      <select [(ngModel)]="filtroAnhoSeleccionado" formControlName="anyo" (change)="seleccionFiltro('anho')"
        class="form-control select_criterios" [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyo'] }" required>
        <option [value]="0">Seleccionar</option>
        <option *ngFor="let anho of filtroAnhos" [value]="anho">{{anho}}</option>
      </select>
      <div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback">
        <div *ngIf="tieneErrores['anyo']">Campo requerido</div>
      </div>
    </div>
    <div class="col-2">
      <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
      <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
      <select [(ngModel)]="filtroPeriodoSeleccionado" formControlName="periodo" (change)="seleccionFiltro('periodo')"
        class="form-control select_criterios" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }"
        required>
        <option [value]="0">Seleccionar</option>
        <option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of filtroPeriodos">
          {{periodo.periodoDescripcion}}
        </option>
      </select>
      <div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback">
        <div *ngIf="tieneErrores['periodo']">Campo requerido</div>
      </div>
    </div>
    <div class="col-3">
      <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
      <label class="titulo_criterios-obligatorio ml-2" *ngIf="rolUsuario === 2">(obligatorio)</label>
      <select [(ngModel)]="filtroSedeSeleccionado" formControlName="sede" (change)="seleccionFiltro('sede')"
        class="form-control select_criterios" [ngClass]="{ 'is-invalid': submitted && tieneErrores['sede'] }">
        <option [value]="0">Seleccionar</option>
        <option [value]="sede.sedeId" *ngFor="let sede of listaSedes">{{sede.descripcion}}</option>
      </select>
      <div *ngIf="submitted && tieneErrores['sede']" class="invalid-feedback">
        <div *ngIf="tieneErrores['sede']">Campo requerido</div>
      </div>
    </div>
    <div class="col-3">
      <label class="titulo_criterios" for="exampleFormControlSelect2">Sigla asignatura</label>
      <div class="input-group mb-0">
        <mat-autocomplete #autoAsignatura="matAutocomplete" [displayWith]="displayFnAsignatura">
          <mat-option *ngFor="let asignatura of filteredAsignatura | async" [value]="asignatura">
            {{asignatura?.codigo}}
          </mat-option>
        </mat-autocomplete>
        <input type="text" class="form-control select_criterios" placeholder="Sigla asignatura"
          aria-describedby="basic-addon2" [formControl]="searchAsignaturaForm" formControlName="asignatura"
          [matAutocomplete]="autoAsignatura" (ngModelChange)="resetearValidacion();" maxlength="50" [ngClass]="{ 'is-invalid': submitted && tieneErrores['asignatura'] }">
          <div *ngIf="submitted && tieneErrores['asignatura']" class="invalid-feedback">
            <div *ngIf="tieneErrores['asignatura']">Debes seleccionar una asignatura</div>
          </div>
      </div>
    </div>
    
    <div class="col-1 centrar_iconos_botones mt-3">
      <button (click)="mostrarReportes()" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR"
        alt="BUSCAR">
        <i class="bi bi-search"></i>
      </button>
    </div>
    <div class="col-1 centrar_iconos_botones mt-3">
      <button (click)="limpiarFiltros()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip"
        data-placement="top" title="LIMPIAR" alt="LIMPIAR">
        <i class="bi bi-x"></i>
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
      <div class="input-group mb-0">
        <mat-autocomplete #autoIdDocente="matAutocomplete" [displayWith]="displayFnIdDocente">
          <mat-option *ngFor="let docente of filteredDocenteId | async" [value]="docente">
            {{docente?.codigo}}
          </mat-option>
        </mat-autocomplete>
        <input type="text" class="form-control select_criterios" placeholder="11111111" aria-describedby="basic-addon2"
          [formControl]="searchIdDocenteForm" formControlName="docenteId" [matAutocomplete]="autoIdDocente"
          [ngClass]="{ 'is-invalid': submitted && tieneErrores['docenteId'] }" required
          (ngModelChange)="resetearValidacion();"
          (keypress)="keypressNumber($event)">
        <div *ngIf="submitted && tieneErrores['docenteId']" class="invalid-feedback">
          <div *ngIf="tieneErrores['docenteId']">Campo requerido</div>
        </div>
      </div>
    </div>
    <div class="col-3">
      <label class="titulo_criterios" for="exampleFormControlSelect2">RUT Estudiante</label>
      <div class="input-group mb-0">
        <input formControlName="rut" type="text" class="form-control select_criterios" minlength="6" maxlength="10"
          [ngClass]="{'resaltar': resaltarError && rut.length != 0}" [(ngModel)]="rut" (ngModelChange)="setFormatoRut()"
          placeholder="11111111-1" aria-describedby="basic-addon2">
      </div>
    </div>
  </div>
</form>
<!-- FIN CRITERIO DE BUSQUEDA -->

<div class="alert alert-success  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeExito">
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeExito}}
  <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close"
    data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true"
    aria-controls="collapseWidthExample">
    <span aria-hidden="true" class="alert-success">&times;</span>
  </button>
</div>

<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="errorRutAlumno">
  <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ errorRutAlumno }}
  <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close"
    data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true"
    aria-controls="collapseWidthExample">
    <span aria-hidden="true" class="alert-danger">&times;</span>
  </button>
</div>
<!-- TABLA -->
<div class="row justify-content-end mt-4 mb-4">
  <button (click)="generarReporte()" class="btn boton-primario mt-4 mr-4" data-toggle="tooltip" data-placement="top"
    title="GENERAR REPORTE" alt="GENERAR REPORTE" style="position: absolute; z-index: 1;">
    GENERAR REPORTE
  </button>
</div>

<div style="margin-top: 10px;">
  <table *ngIf="renderTable" [dtOptions]="dtOptions" id="tabla-notas-parciales" datatable class="row-border hover table-striped display nowrap "
    aria-describedby="tabla notas parciales">
    <thead class="header_tabla">
      <tr>
        <th>Id Proceso</th>
        <th>Fecha</th>
        <th>Usuario</th>
        <th style="width: 15%;">Estado del proceso</th>
        <th class="th-mensaje-observaciones">Observaciones</th>
        <th style="width: 10% !important;">Detalle filtro</th>
        <th class="text-center" style="width: 15%;">Descargar archivo</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let dato of listaReporteCalificaciones; index as i">
        <td class="py-0">
          <p class="celda">{{ dato.idProceso }}</p>
        </td>
        <td class="py-0">
          <p class="celda">{{ dato.fechaProceso }}</p>
        </td>
        <td class="py-0">
          <p class="celda">{{ dato.usuarioCreacion}}</p>
        </td>
        <td class="py-0">
          <span class="badge badge-pill finalizado d-flex justify-content-center py-2"
            *ngIf="dato.estadoProceso == 'F'">Finalizado</span>
          <span class="badge badge-pill en_proceso d-flex justify-content-center py-2"
            *ngIf="dato.estadoProceso == 'EP'">En proceso</span>
          <span class="badge badge-pill error d-flex justify-content-center py-2"
            *ngIf="dato.estadoProceso == 'ER'">Error</span>
        </td>
        <td class="py-0 td-mensaje-observaciones">
          <p class="celda p-mensaje-observaciones">{{ dato.mensajeProceso }}</p>
        </td>
        <td class="py-0">
          <button (click)="mostrarDetalleFiltros(i,dato.docenteId, dato.codigoAsignatura)" type="button" class="btn cantidadCpEx"
            style="text-align:center">Ver</button>
        </td>
        <td class="d-flex justify-content-center py-0">
          <button class="btn p-0 cstm-padding-descarga" *ngIf="dato.estadoProceso == 'F'" (click)="descargarArchivo(dato.idProceso,dato.fechaProceso)" data-toggle="tooltip" data-placement="top"
            title="DESCARGAR ARCHIVO" alt="DESCARGAR ARCHIVO">
            <i class="bi bi-filetype-xlsx icono-tabla"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <table *ngIf="!renderTable" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap "
    aria-describedby="tabla notas parciales">
    <thead class="header_tabla">
      <tr>
        <th>Id Proceso</th>
        <th>Fecha</th>
        <th>Usuario</th>
        <th style="width: 15%;">Estado del proceso</th>
        <th>Observaciones</th>
        <th style="width: 10% !important;">Detalle filtro</th>
        <th class="text-center" style="width: 15%;">Descargar archivo</th>
      </tr>
    </thead>
    <tbody>
    </tbody>
  </table>
</div>
<!-- FIN TABLA -->


<!-- MODAL DETALLE FILTROS -->
<button type="button" class="btn btn-primary d-none" data-toggle="modal" id="btn-cantidadex" data-target="#cantidadEx">
  Launch demo modal
</button>

<div class="modal fade" id="cantidadEx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 style="font-size: 2.5rem !important;" class="modal-title mt-0 ml-4" id="exampleModalLabel">Detalle filtros
        </h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
        <div class="align-items-center my-3 mx-4">
          <p class="mb-4">
            ID Proceso: <strong class="mr-4">{{ detalleFiltros?.idProceso }}</strong>
          </p>
        </div>
        <div class="align-items-center my-3 mx-4">
          <div class="row">
            <div class="col">
              <p>Año: <strong class="porcentajeCalificaciones mr-3">{{ detalleFiltros?.anyo }}</strong>&nbsp;-&nbsp;&nbsp;</p>
            </div>
            <div class="col">
              <p>Periodo: <strong class="porcentajeCalificaciones mr-3">{{ detalleFiltrosEsp?.periodo }}</strong></p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p *ngIf="detalleFiltrosEsp?.codigoAsignatura != null">S. Asignatura: <strong class="porcentajeCalificaciones mr-3">{{ detalleFiltros?.codigoAsignatura }}</strong>&nbsp;-&nbsp;&nbsp;</p>
              <p *ngIf="detalleFiltrosEsp?.codigoAsignatura === null">S. Asignatura: <strong class="porcentajeCalificaciones mr-3">N/S</strong>&nbsp;-&nbsp;&nbsp;</p>
            </div>
            <div class="col">
              <p *ngIf="detalleFiltrosEsp?.sede != null">Sede: <strong class="porcentajeCalificaciones mr-3">{{ detalleFiltrosEsp?.sede }}</strong></p>
              <p *ngIf="detalleFiltrosEsp?.sede === null">Sede: <strong class="porcentajeCalificaciones mr-3">N/S</strong></p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p *ngIf="detalleFiltrosEsp?.docente != null">ID Docente: <strong class="porcentajeCalificaciones mr-3">{{ detalleFiltrosEsp?.docente }}</strong>&nbsp;-&nbsp;&nbsp;</p>
              <p *ngIf="detalleFiltrosEsp?.docente === null">ID Docente: <strong class="porcentajeCalificaciones mr-3">N/S</strong>&nbsp;-&nbsp;&nbsp;</p>
            </div>
            <div class="col">
              <p *ngIf="detalleFiltros?.rutEstudiante != null">RUT Estudiante: <strong class="porcentajeCalificaciones mr-3">{{ detalleFiltros?.rutEstudiante }}</strong>
                <p *ngIf="detalleFiltros?.rutEstudiante === null">RUT Estudiante: <strong class="porcentajeCalificaciones mr-3">N/S</strong></p>
            </div>
          </div>
          
        </div>
      </div>
      <div class="row align-items-center mx-3">
        <p class="titulo_criterios-obligatorio ml-4">(N/S = No seleccionado)</p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="boton-secundario boton_secundario_modal ml-3 my-2" data-dismiss="modal">
          aceptar
        </button>
      </div>
    </div>
  </div>
</div>
<!-- FIN CALIFICACIONES EXÁMENES -->

<br><br>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Modal info
</button>